import { RequiredFieldForm, EmailValidation, FormWithStyles, BrokenFormValidation, FormProcessing } from "../../../../content/blog/do-you-even-need-js-for-your-basic-html-forms/previews/login-form.jsx";
import * as React from 'react';
export default {
  RequiredFieldForm,
  EmailValidation,
  FormWithStyles,
  BrokenFormValidation,
  FormProcessing,
  React
};